export const FETCH_NEWS_BEGIN   = 'FETCH_NEWS_BEGIN';
export const FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS';
export const WILL_UNMOUNT_NEWS = 'WILL_UNMOUNT_NEWS';
export const WILL_UNMOUNT_ARTICLE = 'WILL_UNMOUNT_ARTICLE';
export const SELECT_ARTICLE_FROM_NEWS = 'SELECT_ARTICLE_FROM_NEWS';
export const FETCH_NEWS_ARTICLE_BEGIN   = 'FETCH_NEWS_ARTICLE_BEGIN';
export const FETCH_NEWS_ARTICLE_SUCCESS = 'FETCH_NEWS_ARTICLE_SUCCESS';
export const NEWS_SET_SEARCH_LOCATION_POINTER = 'NEWS_SET_SEARCH_LOCATION_POINTER';
export const NEWS_LOADING = 'NEWS_LOADING';
export const DETAIL_NEWS_LOADING = "DETAIL_NEWS_LOADING";